import { useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';

// Store
import { venusStore } from '@Store/venus';
import { lunaStore } from '@Store/luna';

// Hooks
import { useEventsVenus } from '@Hooks/useEventVenus';
import { VenusWPText } from '@Hooks/useFetchWP';

// Components
import {
  Buyer,
  BuyerInfo,
  BuyerAdd,
  VenusQ1Conclusion,
  VenusQ1Foda,
  VenusQ1Target,
  VenusQ2Conclusion,
  VenusQ2Foda,
} from '@Components/Molecules/Venus';
import { ModalVenus, ModalSalirVenus } from '@Components/Atomos/Modals';
import { ButtonClose } from '@Components/Atomos/Buttons';

// Styles
import style from '@Sass/pages/venus.module.scss';
import base from '@Sass/pages/general.module.scss';

const Venus = () => {
  // Stores
  const { dataVenus } = venusStore(
    (state) => ({
      dataVenus: state.dataVenus,
    }),
    shallow
  );
  const { getLuna } = lunaStore(
    (state) => ({
      getLuna: state.getLuna,
    }),
    shallow
  );

  const { venusGetProjectById, venusConclusionFO, venusConclusionDA, venusGetBuyerPersona } =
    useEventsVenus();
  const { venusQ1, venusQ2, venusQ3, venusQ4 } = VenusWPText();
  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [texts, setTexts] = useState({});
  const [texts2, setTexts2] = useState({});
  const [texts3, setTexts3] = useState({});
  const [texts4, setTexts4] = useState({});
  const [modalSalir, setModalSalir] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (venusQ1) {
      setTexts(venusQ1);
    }
  }, [venusQ1]);

  useEffect(() => {
    if (venusQ2) {
      setTexts2(venusQ2);
    }
  }, [venusQ2]);

  useEffect(() => {
    if (venusQ3) {
      setTexts3(venusQ3);
    }
  }, [venusQ3]);

  useEffect(() => {
    if (venusQ4) {
      setTexts4(venusQ4);
    }
  }, [venusQ4]);

  // Manejo del proyecto mercurio
  useEffect(() => {
    handleProjectById();
  }, []);

  // validamos si existe un proyecto y actualizamos estado
  const handleProjectById = async () => {
    const res = await venusGetProjectById();
    if (res.code === 0) {
      const { painpoints, fortalezas, oportunidades, debilidades, amenazas } = res.data;
      if (painpoints.length === 0) {
        setPage(1);
        return;
      }
      if (fortalezas.length === 0 || oportunidades.length === 0) {
        setPage(2);
        return;
      }
      if (debilidades.length === 0 || amenazas.length === 0) {
        setPage(3);
        return;
      }
      const fo = await venusConclusionFO();
      if (fo.code === 0) {
        const { fortalezas_oportunidades, conclusion } = fo.data;
        if (fortalezas_oportunidades.length === 0 || conclusion === '') {
          setPage(4);
          return;
        }
      }
      const da = await venusConclusionDA();

      if (da.code === 0) {
        const { oportunidades_debilidades, conclusion } = da.data;
        if (oportunidades_debilidades.length === 0 || conclusion === '') {
          setPage(5);
          return;
        }
      }
      const buyer = await venusGetBuyerPersona();
      if (buyer.code === 0) {
        const propiedades = Object.values(buyer.data);
        const algunaPropiedadVacia = propiedades.some((valor) => valor === '');
        if (algunaPropiedadVacia) {
          setPage(5);
          return;
        }
      }
      setPage(1);
    }
  };
  return (
    <section className={base.planetPageMain}>
      {modalSalir ? (
        <ModalSalirVenus
          title="Estás a punto de salir"
          message="¿Deseas guardar tu información?"
          setModalSalir={setModalSalir}
          data={dataVenus}
          proyect={getLuna().id}
          page={page}
        />
      ) : null}

      {modal ? (
        <ModalVenus
          title=""
          message={message}
          buttonName="Okay"
          setPage={setPage}
          setModal={setModal}
          page={page}
        />
      ) : null}

      <div>
        <ButtonClose setModalSalir={setModalSalir} titlePage={title} />
        <div className={style.Venus}>
          <div className={base.pageContainer}>
            <div className={style.venusContainer}>
              {page === 1 ? (
                <VenusQ1Target
                  setPage={setPage}
                  setTitle={setTitle}
                  texts={texts}
                  dataVenus={dataVenus}
                />
              ) : null}
              {page === 2 ? (
                <VenusQ1Foda setPage={setPage} setTitle={setTitle} texts={texts2} />
              ) : null}
              {page === 3 ? (
                <VenusQ2Foda
                  setPage={setPage}
                  setModal={setModal}
                  setTitle={setTitle}
                  texts={texts2}
                  setMessage={setMessage}
                />
              ) : null}
              {page === 4 ? (
                <VenusQ1Conclusion
                  dataVenus={dataVenus}
                  setPage={setPage}
                  setModal={setModal}
                  setTitle={setTitle}
                  texts={texts3}
                  setMessage={setMessage}
                />
              ) : null}
              {page === 5 ? (
                <VenusQ2Conclusion
                  dataVenus={dataVenus}
                  setPage={setPage}
                  setModal={setModal}
                  setTitle={setTitle}
                  texts={texts3}
                  setMessage={setMessage}
                />
              ) : null}
              {page === 6 ? <BuyerInfo setPage={setPage} setTitle={setTitle} /> : null}
              {page === 7 ? (
                <Buyer
                  setPage={setPage}
                  setModal={setModal}
                  setTitle={setTitle}
                  texts={texts4}
                  setMessage={setMessage}
                />
              ) : null}
              {page === 8 ? (
                <BuyerAdd
                  setPage={setPage}
                  setModal={setModal}
                  setTitle={setTitle}
                  texts={texts4}
                  setMessage={setMessage}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Venus;
